module.exports = __webpack_public_path__ + "img/ic_fb.c1c17d37.svg";